exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.selected-menus[data-v-fcc8f0a8] {\n  list-style: none;\n  padding-left: 0;\n}\n.selected-menu[data-v-fcc8f0a8] {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n", ""]);

// exports
